import {UserModel} from '../../../shared/model/users/UserModel.js';
import {GigyaModel} from '../../../shared/model/GigyaModel';
import {SessionStorageUtil} from '../../../shared/utils/SessionStorageUtil';
import {AppFeaturesModel} from '../../../shared/model/app-features/AppFeaturesModel';

export const GIGYA = new GigyaModel();
export const CURRENT_USER = new UserModel();
export const APP_FEATURES = new AppFeaturesModel({}, {CURRENT_USER});

export function expire () {

    CURRENT_USER.renew();
    SessionStorageUtil.clear();
    APP_FEATURES.renew();

    localStorage.removeItem('HEALTHY_FIELDS_REGISTRATION');
}


// WEBPACK FOOTER //
// ./js/login/resources/SessionObjects.js